import { DS_BRIEF_CREATE_OTHER_DESIGN_URL } from '@99designs/i18n';

export const STANDARD_PREVIEW_IMAGE =
    'https://cdn.dst.vistaprint.io/DefaultCartImages/StandardDify.png';

export const DRAFT_BRIEF_STATUS = 'DRAFT_BRIEF_REQUEST_IN_PROGRESS';

export const PENDING_FULFILMENT_STATUS = 'PENDING_FULFILMENT';

// Default route used when starting a new project from the dashboard.
export const NEW_PROJECT_ROUTE = DS_BRIEF_CREATE_OTHER_DESIGN_URL;
